import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Checkbox from '../TailwindComponents/CheckBox';
import { FileGlyph } from '../../Files/fileGlyphs';
import { formatFileSize } from '../attachments/attachmentModel';

/** One pickable document in the Files picker - Files or SharePoint alike. */
const PickerFileRow: React.FC<{
  name: string;
  size?: number | null;
  mime?: string | null;
  /** Extra meta after the size (a date, say). */
  detail?: string;
  checked: boolean;
  disabled: boolean;
  unsupported: boolean;
  onToggle: () => void;
}> = ({ name, size, mime, detail, checked, disabled, unsupported, onToggle }) => {
  const { t } = useTranslation();
  const meta = [
    typeof size === 'number' ? formatFileSize(size) : '',
    detail || '',
    unsupported ? t('Not supported here') : '',
  ]
    .filter(Boolean)
    .join(' · ');
  return (
    <li
      className={clsx(
        'flex items-center gap-2 rounded-md px-2.5 py-2 transition-colors',
        checked ? 'bg-champagne/10' : 'hover:bg-surface-sunken/70',
      )}
    >
      <FileGlyph fileName={name} mimeType={mime || undefined} className="h-5 w-5 flex-shrink-0" />
      <Checkbox
        label={name}
        translate={false}
        description={meta || undefined}
        checked={checked}
        disabled={disabled}
        onChange={onToggle}
        className="min-w-0 flex-1"
      />
    </li>
  );
};

export default PickerFileRow;
